export { default } from 'modal-enhanced-react-native-web';
